import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from 'src/app/shared/common/common.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

@Component({
    selector: 'app-dependent-token',
    templateUrl: './dependent-token.component.html',
    styleUrl: './dependent-token.component.scss',
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, NgIf, MatError, MatButton, MatProgressSpinner]
})
export class DependentTokenComponent implements OnInit {
    content: any;
  generateTokenForm: FormGroup;
  isSubmitting = false;
  token:string='';
  constructor(
    private readonly bookingContentService: BookingContentService, private readonly fb: FormBuilder,
    public readonly _CommonService: CommonService,
    private readonly _CamService: CamService,
    private readonly _ToastrApiService: ToastrApiService
  ) {
    this.generateTokenForm = this.fb.group({
      emailAddress: ['', [Validators.required, Validators.email]],
      guid:['',[Validators.required]]
    });
  }


  async onGenerateToken(): Promise<void> {
    if (this.generateTokenForm.invalid || this.isSubmitting) {
      this.generateTokenForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
   const  payload={
    email: this.generateTokenForm.get('emailAddress')?.value,
    b2bUserGuid:this.generateTokenForm.get('guid')?.value
    }
    try {
      const response = await this._CamService.generateDependentToken(payload);
      if (response?.status === 'Created' || response?.status === 'Success') {
        this._ToastrApiService.show(
          'success',
          response?.message || 'Token created successfully.'
        );
        this.token = response?.data;
        if (this.token) {
            const baseUrl = window.location.origin;
            const targetUrl = `${baseUrl}/dependent-onboard?token=${encodeURIComponent(this.token)}`;
            window.open(targetUrl, '_self'); 
      }
      } else {
        this._ToastrApiService.show(
          'error',
          response?.message || 'Failed to create token.'
        );
      }
    } catch (error: any) {
      const message =
        error?.error?.message || error?.message ||
        'Something went wrong while creating token. Please try again.';
      this._ToastrApiService.show('error', message);
    } finally {
      this.isSubmitting = false;
    }
  }

    ngOnInit(): void {
        this.bookingContentService.content$.subscribe((res: any) => { this.content = res; });
        
    }
}
